import isVueComponent from '../utils/isVueComponent'

export default function genComponentDesc(component, defaultIs) {
  if (typeof component === 'object') {
    if (isVueComponent(component)) {
      return {
        is: component,
        props: {},
        on: {},
      }
    }

    const {
      is, props = {}, on = {}, ...otherProps
    } = component

    return {
      is: is ?? defaultIs,
      props: { ...props, ...otherProps },
      on,
    }
  } if (typeof component === 'string') {
    return {
      is: component,
      props: {},
      on: {},
    }
  }
  return {
    is: defaultIs,
    props: {},
    on: {},
  }
}
